/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Theme adapter for the following page of the users dashboard
namespace('Slzr.Theme.UserDashboard', function(exports, top) {
  let jQuery;
  const $ = (jQuery = top.Slzr.jQuery);

  // Remove a group
  //
  // Takes an id of the item without the '#'
  return exports.removeFollowedItem = function(options) {
    const elem = $(`#${options.item}`);
    if (elem) { return elem.remove(); }
  };
});